import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    components: {
    },
})

export default class DisolventesWeb extends Vue {

    public created() {
        document.documentElement.scrollTop;
    }

    public get language() {
        return this.$root.$i18n.locale.toString();
    }

    public goTo(route: string) {
        this.$router.push({ name: route });
    }
    
    public backToDemostrador() {
        this.$router.push({ name: 'Demostrador' });
    }

}